<template>
  <div class="transactions">
    <va-card :title="$t('transactions.cards.title')">
      <template slot="actions">
        <va-button
          v-if="invoice.last_transaction === 'ATIVA'"
          @click="processar"
        >
          Processar
        </va-button>
      </template>
      <va-notification v-if="showNotif">
        {{ respMsg }}
        <div class="va-notification__close-icon">
          <i
            @click="showNotif = false"
            class="va-icon ion-md-close ion" style="color: rgb(0, 255, 48);">
          </i>
        </div>
      </va-notification>
      <va-data-table
        v-if="!$apollo.queries.invoice.loading"
        :fields="fields"
        :data="invoice.transactions"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode>
        <template slot="actions" slot-scope="props">
          <va-button
            v-if="props.rowData.status === 'CONCLUIDA' && invoice.last_transaction != 'DEVOLVIDO'"
            @click="devolver(props.rowData)"
          >
            Devolver
          </va-button>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalProcessar"
      size="small"
      :title="tituloModal"
      :message="textoModal"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="execProcessar"
      @cancel="cancelar"
    />
    <va-modal
      v-model="modalDevolver"
      size="small"
      :title="tituloModal"
      :message="textoModal"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="execDevolver"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
const perPage = 10
export default {
  name: 'transactions',
  props: {
    invoiceId: {
      required: true,
    },
  },
  methods: {
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.transactions.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    processar () {
      this.tituloModal = 'Processar Invoice'
      this.textoModal = 'Deseja processar novamente essa invoice?'
      this.modalProcessar = true
      this.showNotif = true
      this.respMsg = 'Invoice processada com sucesso!'
    },
    execProcessar () {
      this.$axios.post(
        '/api/process_pix',
        {
          txid: this.invoice.txid,
        },
      ).then(_ => {
        this.showNotif = true
        this.respMsg = 'Invoice processada com sucesso!'
        this.$apollo.queries.pages.refetch()
        this.$apollo.queries.invoice.refetch()
      }).catch(_ => {
        this.showNotif = true
        this.respMsg = 'Erro ao processar Invoice!'
      })
    },
    devolver (transac) {
      this.transacDev = transac
      this.tituloModal = 'Devolver Invoice'
      this.textoModal = 'Deseja devolver o valor para o cliente?'
      this.modalDevolver = true
    },
    cancelar () {
      this.transacDev = null
      this.modalDevolver = false
      this.modalProcessar = false
    },
    execDevolver () {
      this.$axios.post(
        '/api/devolucao',
        {
          id: this.invoice.gnid,
          e2e: this.transacDev.e2e,
          valor: this.transacDev.amount,
        },
      ).then(_ => {
        this.showNotif = true
        this.respMsg = 'Devolução concluida com sucesso!'
        this.$apollo.queries.pages.refetch()
        this.$apollo.queries.invoice.refetch()
      }).catch(_ => {
        this.showNotif = true
        this.respMsg = 'Erro ao devolver valor!'
      })
    },
  },
  data () {
    return {
      invoice: [],
      page: 1,
      modalProcessar: false,
      modalDevolver: false,
      showNotif: false,
      tituloModal: '',
      textoModal: '',
      respMsg: '',
      transacDev: null,
      perPage: perPage,
      pages: null,
      loading: false,
    }
  },
  apollo: {
    invoice: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $invoiceId: Int!) {
        invoice: invoice_by_pk(id: $invoiceId) {
          gnid
          txid
          last_transaction
          transactions(limit: $perPage, offset: $page, order_by: {id: asc}) {
            id
            invoice{
              client{
                email
              }
            }
            invoice_id
            created_at
            status
            code
            amount
            e2e
          }
        }
      }
      `,
      variables () {
        return {
          invoiceId: this.invoiceId,
          perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($invoiceId: Int!)  {
        pages: transaction_aggregate(where: {invoice_id: {_eq: $invoiceId}})  {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          invoiceId: this.invoiceId,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'invoice',
        title: this.$t('transactions.headings.client'),
        width: '35%',
        callback (value) {
          return value.client.email
        },
      }, {
        name: 'invoice_id',
        title: this.$t('transactions.headings.invoice_id'),
        width: '10%',
      }, {
        name: 'status',
        title: this.$t('transactions.headings.status'),
        width: '20%',
      }, {
        name: '',
        title: this.$t('transactions.headings.amount'),
        width: '10%',
        callback (value) {
          return value.code + ' ' + value.amount
        },
      }, {
        name: 'e2e',
        title: this.$t('transactions.headings.e2e'),
        width: '20%',
      }, {
        name: 'created_at',
        title: this.$t('invoices.headings.created_at'),
        width: '10%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('invoice')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.invoice.refetch()
    }
  },
}
</script>

<style lang="scss">
.va-notification__close-icon {
  padding: 0.0625rem 0.5rem;
  font-size: 1.5rem;
  cursor: pointer;
  margin-left: auto;
}
</style>
